import { Button, Modal } from "react-bootstrap";
import css from "./styles.module.css"
import { useEffect, useState } from "react";
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient";

export default function ModalDocumentoMoverParaPasta({ show, handleClose, handlePasta }:iProps) {
    const [pastas, setPastas] = useState<any[]>([])
    const [erroCarregar, setErroCarregar] = useState<boolean>(false)
    useEffect(() => {
        getPastas()
        // eslint-disable-next-line
    }, [])
    async function getPastas() {
        const api = await reqGetNew(ApiEndpoints.documentoListarPastas)
        if (api.status === 200) {
            setPastas(api.data)
        } else {
            setErroCarregar(true)
        }
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title><b>Selecione a pasta</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    erroCarregar &&
                    <div>
                        <p style={{display: "flex", alignItems: "center"}}>
                            <span className="material-symbols-outlined">
                            error
                            </span>
                            Erro ao carregar as pastas do sistema, tente novamente mais tarde ou entre em contato com o suporte!
                        </p>
                        <br></br>
                    </div>
                }

                {
                    !erroCarregar &&
                    <div className={css.div_pasta} onClick={() => { handlePasta(null) }}>
                        <span className="material-symbols-outlined" style={{marginRight: "10px"}}>
                            folder
                        </span>
                        <p>Pasta Inicial</p>
                    </div>
                }
                {
                    pastas.map((pasta, idx, arr) => {
                        let margin_left = 10 * pasta.sub_nivel
                        return (
                            <div className={css.div_pasta} key={idx} onClick={() => { handlePasta(pasta.id_pasta) }} style={{
                                marginLeft: `${margin_left}px`
                            }}>
                                <span className="material-symbols-outlined" style={{marginRight: "10px"}}>
                                    folder
                                </span>
                                <p>{pasta.nome}</p>
                            </div>
                        )
                    })
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}
interface iProps {
    show: boolean
    handleClose: any
    handlePasta: any
}